import React, { useState, useEffect } from "react";
import {
    BrowserRouter as Router, Link, NavLink, useLocation
} from "react-router-dom";
import axios from "axios";
import baseUrl from "../../../../utils/Constants";
import MenuNavbar from '../../../MenuNavbar';
import Floaticons from '../../../Floaticons';
import "../TabContentStyles.css";
import { Breadcrumbs } from "@material-ui/core";
import ApplicationSecurity from "./ApplicationSecurity/ApplicationSecurity";
import CloudSecurity from "./CloudSecurity/CloudSecurity";
import DataAISecurity from "./DataAISecurity/DataAISecurity";
import EmergingTechnology from "./EmergingTechnologySecurity/EmergingTechnology";
import EnterprisePlatformSecurity from "./EnterprisePlatformSecurity/EnterprisePlatformSecurity";
import IdentityAccessManagement from "./IdentityAccessManagement/IdentityAccessManagement";
import ZeroTrustSASEandCybersecurityMesh from "./ZeroTrust/ZeroTrustSASEandCybersecurityMesh";

function CyberProtectionTab() {
    const [value, setValue] = React.useState(0);
    const [appSec, setappSec] = useState([]);
    const [cloudSec, setcloudSec] = useState([]);
    const [dataAI, setdataAI] = useState([]);
    const [emerTech, setemerTech] = useState([]);
    const [entPlatformSec, setentPlatformSec] = useState([]);
    const [accessMan, setaccessMan] = useState([]);
    const [zeroTrust, setzeroTrust] = useState([]);
    const location = useLocation();
    const propsData = location.state ? location.state.tabID : null;
    const [displaySkill, setDisplaySkill] = useState('Application-Security');

        const getCyberProtection = async () => {
    
         const response = await axios.get(`${baseUrl}/cyberprotection`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token")
          }
        }
        ).then(res => {
          console.log("getall", res);
          if(res.data.result.length > 0){
    
            const arr = res.data.result;
            setappSec(arr.filter((item) => item.sub_practice.includes("Application Security")));
            setcloudSec(arr.filter((item) => item.sub_practice.includes("Cloud Security")));
            setaccessMan(arr.filter((item) => item.sub_practice.includes("Access Management")));
            setdataAI(arr.filter((item) => item.sub_practice.includes("AI Security")));
            setemerTech(arr.filter((item) => item.sub_practice.includes("Emerging Technology")));
            setentPlatformSec(arr.filter((item) => item.sub_practice.includes("Enterprise Platform Security")));
            setzeroTrust(arr.filter((item) => item.sub_practice.includes("Zero Trust")));
          }
          // setAllbooks(res.data.result);
          
          return res.data
        }).catch(err => {console.log("error")});
    
      }
    
        useEffect(() => {
            getCyberProtection();
        }, [])

    return (
        <><div className="banner-container">
            <img src="images/Banner1.png" alt="banner" className="banner-img" />
            <MenuNavbar />
        </div>
            <Floaticons />
            <h2 className="ssa-heading">
                Security Specialization Academy
            </h2>
            <div className="TabPanelWrapper">
                <div className="SSA-breadcrumbLinks">
                    <Breadcrumbs separator="/" aria-label="breadcrumb">
                        <NavLink className="menu_title" to="/SecuritySpecializationAcademyNew">
                            <img src="images/SSA/Backbutton.png" class="breadcrumbBack" />
                            Cyber Protection
                        </NavLink>
                        {displaySkill === "Application-Security" ? (
                            <NavLink className="menu_title" to="/CyberProtectionNew#Application-Security">
                               Application Security
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "CloudSecurity" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberProtectionNew#CloudSecurity"
                            >
                                Cloud Security
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "Data&AISecurity" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberProtectionNew#Data&AISecurity"
                            >
                               Data & AI Security
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "EmergingTechnology" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberProtectionNew#EmergingTechnology"
                            >
                                Emerging Technology
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "EnterprisePlatformSecurity" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberProtectionNew#EnterprisePlatformSecurity"
                            >
                                Enterprise Platform Security
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "Identity&AccessManagement" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberProtectionNew#Identity&AccessManagement"
                            >
                                Identity & Access Management
                            </NavLink>
                        ) : (
                            ""
                        )}
                        {displaySkill === "ZeroTrustSASEandCybersecurityMesh" ? (
                            <NavLink
                                className="menu_title"
                                to="/CyberProtectionNew#ZeroTrustSASEandCybersecurityMesh"
                            >
                                Zero Trust, SASE and Cybersecurity Mesh
                            </NavLink>
                        ) : (
                            ""
                        )}
                    </Breadcrumbs>
                </div>
                <div className="tabNavMenu">
                    <a
                        className={
                            displaySkill === "Application-Security" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => setDisplaySkill("Application-Security")}
                        href="#Application-Security"
                    >
                        <span>Application Security</span>
                    </a>
                    <a
                        className={
                            displaySkill === "CloudSecurity" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("CloudSecurity");
                        }}
                        href="#CloudSecurity"
                    >
                        <span>Cloud Security</span>
                    </a>
                    <a
                        className={
                            displaySkill === "Data&AISecurity" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("Data&AISecurity");
                        }}
                        href="#Data&AISecurity"
                    >
                        <span>Data & AI Security</span>
                    </a>
                    <a
                        className={
                            displaySkill === "EmergingTechnology" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("EmergingTechnology");
                        }}
                        href="#EmergingTechnology"
                    >
                        <span>Emerging Technology</span>
                    </a>
                    <a
                        className={
                            displaySkill === "EnterprisePlatformSecurity" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("EnterprisePlatformSecurity");
                        }}
                        href="#EnterprisePlatformSecurity"
                    >
                        <span>Enterprise Platform Security</span>
                    </a>
                    <a
                        className={
                            displaySkill === "Identity&AccessManagement" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("Identity&AccessManagement");
                        }}
                        href="#Identity&AccessManagement"
                    >
                        <span>Identity & Access Management</span>
                    </a>

                     <a
                        className={
                            displaySkill === "ZeroTrustSASEandCybersecurityMesh" ? "subtabActive" : "subtabInactive"
                        }
                        onClick={() => {
                            setDisplaySkill("ZeroTrustSASEandCybersecurityMesh");
                        }}
                        href="#ZeroTrustSASEandCybersecurityMesh"
                    >
                        <span>Zero Trust, SASE and Cybersecurity Mesh</span>
                    </a>
            
                </div>
                <div className="TabPanel-Wrap">
                    {displaySkill === "Application-Security" ? (
                        <ApplicationSecurity appSec = {appSec}/>
                    ) : (
                        ""
                    )}

                    {displaySkill === "CloudSecurity" ? (
                        <CloudSecurity cloudSec = {cloudSec}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "Data&AISecurity" ? (
                        <DataAISecurity dataAI = {dataAI}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "EmergingTechnology" ? (
                        <EmergingTechnology emerTech = {emerTech}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "EnterprisePlatformSecurity" ? (
                        <EnterprisePlatformSecurity entPlatformSec = {entPlatformSec}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "Identity&AccessManagement" ? (
                        <IdentityAccessManagement accessMan = {accessMan}/>
                    ) : (
                        ""
                    )}
                    {displaySkill === "ZeroTrustSASEandCybersecurityMesh" ? (
                        <ZeroTrustSASEandCybersecurityMesh zeroTrust = {zeroTrust}/>
                    ) : (
                        ""
                    )}

                </div>
            </div>
        </>
    );
}

export default CyberProtectionTab;